module.exports = __webpack_public_path__ + "static/03-un-0400127@2x-f13ffa7bed21d59c6ae99b58e3ea6a8d.png";